import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import './ContactDetailPage.scss';

import ContactDetail from '../../Components/molecules/ContactDetail/ContactDetail';
import Pagination from '../../Components/molecules/Pagination/Pagination';
import Button from '../../Components/atoms/Button/Button';

// import { CustomRequestContext } from '../../api/context/custom-request-context';
import { fetchPeopleContact } from '../../Apis/actions/person-search-actions';

// const CustomRequests = React.lazy(() =>
//   import('../../components/molecules/CustomRequests/CustomRequests')
// );

const ContactDetailPage = () => {
  const { isLoadingPeopleContacts, people } = useSelector((state) => state.personSearchReducer);
  // const history = useHistory();
  const location = useLocation();
  const state = location.state;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  // const [showMessagePanel, setShowMessagePanel] = useState(false);
  // const [requestType, setRequestType] = useState('Need a specific contact');

  // const isPublicist =
  //   JSON.parse(localStorage.getItem('userData'))?.value?.current_membership === 'PUBLICIST';

  const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
  const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;

  const formattedSubject = 'Request for a contact not found in the Search Engine';
  const mailToLink =
    'mailto:bot-user-sending-us-m-aaaaqcwxmgi4evf6kftva3jjou@tmxnews.slack.com?subject=' +
    encodeURIComponent(formattedSubject);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    dispatch(
      fetchPeopleContact({
        ...state,
        AddressLine1: state.AddressLine1,
        AddressLine2: state.AddressLine2,
        AgeRangeMinAge: state.AgeRange ? state.AgeRange.split('-')[0] : state?.AgeRangeMinAge,
        AgeRangeMaxAge: state.AgeRange ? state.AgeRange.split('-')[1] : state?.AgeRangeMaxAge,
        Dob: state.Dob !== '' ? new Date(state.Dob) : state.Dob,
        page: { current: pageNumber, size: 20 },
        email: isEmailPresent,
        token: isTokenPresent
      })
    );
  };

  const handleSubmitQuery = (payload) => {
    dispatch(fetchPeopleContact(payload));
  };

  useEffect(() => {
    if (people && Object.keys(people?.search_query).length === 0 && state) {
      dispatch(
        fetchPeopleContact({
          ...state,
          AddressLine1: state.AddressLine1,
          AddressLine2: state.AddressLine2,
          AgeRangeMinAge: state.AgeRange ? state.AgeRange.split('-')[0] : state?.AgeRangeMinAge,
          AgeRangeMaxAge: state.AgeRange ? state.AgeRange.split('-')[1] : state?.AgeRangeMaxAge,
          Dob: state.Dob !== '' ? new Date(state.Dob) : state.Dob,
          page: { current: currentPage, size: 20 },
          email: isEmailPresent,
          token: isTokenPresent
        })
      );
    }
  }, [dispatch, state, people, currentPage, isEmailPresent, isTokenPresent]);

  return (
    <div className="tmx-contactDetailPage">
      {/* Message panel for contact requests */}
      {/* {showMessagePanel ? (
        <>
          <div
            className="tmx-navigation__panelBackground"
            onClick={() => setShowMessagePanel(false)}
            role={'button'}
            tabIndex={0}
            onKeyDown={() => setShowMessagePanel(false)}></div>
          <CustomRequestContext.Provider
            value={{
              closeModal: () => setShowMessagePanel(false),
              dispatch: dispatch,
              requestTypeFromNav: requestType
            }}>
            <Suspense fallback={<></>}>
              <CustomRequests />
            </Suspense>
          </CustomRequestContext.Provider>
        </>
      ) : null} */}

      {/* FindAnyone Search results page */}
      <div className="tmx-contactDetailPage__searchWrapper">
        <div>
          <Button
            buttonIcon="arrow-right"
            iconSize="ginormous"
            className="tmx-contactDetailPage__backToContactPage"
            handleClick={() => navigate('/personsearch')}>
            Back to Regular Person search{' '}
          </Button>
        </div>
        <div className="tmx-contactDetailPage__searchTermContainer">
          {isLoadingPeopleContacts && (
            <div className="tmx-contactDetailPage__spinnerContainer">
              <span className="tmx-contactDetailPage__spinner"></span>
            </div>
          )}
          {people && (
            <div
              className={classNames('tmx-contactDetailPage__searchResult', {
                loading: isLoadingPeopleContacts,
                hide: !people || (people?.search_result?.length === 0 && !isLoadingPeopleContacts)
              })}>
              {isLoadingPeopleContacts ? 'Loading' : 'Showing'}
              {isLoadingPeopleContacts
                ? ' results'
                : ` results ${(currentPage - 1) * 20 + 1}-${
                    20 * currentPage > people?.search_query?.meta?.expectedCount
                      ? people?.search_query?.meta?.expectedCount
                      : 20 * currentPage
                  }
            of (${people?.search_query?.meta?.expectedCount})`}{' '}
              for {state.FirstName && `First Name: ${state.FirstName},`}{' '}
              {state.MiddleName && `Middle Name: ${state.MiddleName};`}{' '}
              {state.LastName && `Last Name: ${state.LastName},`}{' '}
              {state.Akas && `Akas: ${state.Akas},`} {state.Dob && `Dob: ${state.Dob},`}{' '}
              {state.AgeRange && `AgeRange: ${state.AgeRange},`}{' '}
              {state.AgeRangeMinAge || state.AgeRangeMaxAge
                ? `AgeRange: ${state.AgeRangeMinAge ? state.AgeRangeMinAge : ''} ${
                    state.AgeRangeMaxAge && state.AgeRangeMaxAge !== 'undefined'
                      ? `- ${state.AgeRangeMaxAge},`
                      : ''
                  }`
                : ''}{' '}
              {state.Address && `Address: ${state.Address};`}{' '}
              {state.AddressLine2 && `${state.AddressLine2};`}{' '}
              {state.City && `City: ${state.City};`} {state.State && `State: ${state.State};`}{' '}
              {state.Zip && `Zip: ${state.Zip},`} {state.Email && `Email: ${state.Email},`}{' '}
              {(state.ReversePhone || state.Phone) &&
                `Phone: ${state.ReversePhone || state.Phone},`}
            </div>
          )}
        </div>
      </div>
      {isLoadingPeopleContacts ? (
        <div>
          {/* <div className="tmx-contactDetailPage__mockResultCount"></div> */}
          <div className="tmx-contactDetailPage__mockContainer">
            <div className="tmx-contactDetailPage__mockHeader"></div>
          </div>
          <div className="tmx-contactDetailPage__mockContainer">
            <div className="tmx-contactDetailPage__mockHeader"></div>
          </div>
          <div className="tmx-contactDetailPage__mockContainer">
            <div className="tmx-contactDetailPage__mockHeader"></div>
          </div>
          <Pagination
            paginate={paginate}
            currentPage={currentPage}
            isLoadingPeopleContacts={isLoadingPeopleContacts}
            totalPages={people?.search_query?.meta?.totalPages}
          />
        </div>
      ) : !people || people?.search_result?.length === 0 ? (
        <>
          <div className="tmx-contactDetailPage__noResultFoundTitle">No Result Found </div>
          <p className="tmx-contactDetailPage__noResultFoundSubText">
            <Link
              to={{
                pathname: '/personsearch',
                state: {
                  // section: 'database',
                  persistedSearchTerms: { FirstName: state.FirstName }
                }
              }}
              className="tmx-contactDetailPage__noResultFoundSubTextLink">
              Edit your search and try again.
            </Link>{' '}
            Still having trouble? Please contact us here.
          </p>

          <div className="tmx-contactDetailPage__btnContainer">
            <Button
              className="tmx-contactDetailPage__btn"
              buttonType="blue"
              handleClick={() => {
                window.open(mailToLink, '_self');
              }}>
              Message TMX
            </Button>
          </div>
        </>
      ) : (
        <>
          {people?.search_result?.map((people, index) => (
            <div key={index} className="tmx-contactDetailPage__contact">
              <ContactDetail
                people={people}
                handleSubmitQuery={handleSubmitQuery}
                firstName={state.FirstName}
                MiddleName={state.MiddleName}
                lastName={state.LastName}
              />
            </div>
          ))}
          <Pagination
            paginate={paginate}
            currentPage={currentPage}
            isLoadingPeopleContacts={isLoadingPeopleContacts}
            totalPages={people?.search_query?.meta?.totalPages}
          />
        </>
      )}
    </div>
  );
};

export default ContactDetailPage;
